/**
 * ins http方法用到的拦截器
 */

import { RequestParams } from "@/api/types";
import { IOS_HEADERS } from "@/api/ins/base/ins_base_const";
import InsCookieHandle from "../cookie_manager/persist_cookie";
import { isJSON } from "@/utils/lodash";
import { transformParamsToString } from "@/api/utils/api_helpers";
import { showLoginRequired } from "@/services/dialog_utils";
import InsLoginCookieHandle from "@/api/ins/cookie_manager/login_cookie";
import { act_users_action } from "@/services/earn_coins/observer/act_users_observer";
/**
 * 设置默认cookie
 * @param config
 */
export const requestCookiePreLoad = async (config: RequestParams) => {
  const { extra_data }: any = config;
  if (extra_data && extra_data.user_id) {
    const findCookie = await InsCookieHandle.getCookieString(
      extra_data.user_id
    );
    // preload
    findCookie && (config.headers.cookie = findCookie);
  } else {
    const preloadCookie = InsLoginCookieHandle.getCookie();
    preloadCookie && (config.headers.cookie = preloadCookie);
  }
  return config;
};
/**
 * 设置默认headers
 * @param config
 */
export const defaultHeader = (config: RequestParams) => {
  const defaultHeaders = config.extra_data && config.extra_data.default_headers;
  return defaultHeaders && config.headers
    ? {
        ...config,
        headers: {
          ...IOS_HEADERS(),
          ...config.headers
        }
      }
    : defaultHeaders && !config.headers
    ? {
        ...config,
        headers: IOS_HEADERS()
      }
    : config;
};
/**
 * 处理get方法的url以及post方法的body
 * @param config
 */
export const handleUrlBody = (config: RequestParams) => {
  if (config.method === "GET") {
    const newurl = config.params
      ? `${config.url}?${transformParamsToString(config.params)}`
      : config.url;
    config.url = newurl;
  }
  return config;
};

export const responseCookieFactory = (responseData: any) => {
  const { request, cookies } = responseData;
  const isLogin = request && request.extra_data && request.extra_data.is_login;
  // 登录的api，需要更新cookie
  if (isLogin && cookies) {
    // 更新并存储cookie
    InsLoginCookieHandle.updateCookie(cookies); // 登录临时缓存cookie
    const temp_cookies = InsCookieHandle.getCookieValue(cookies);
    if (temp_cookies && temp_cookies.ds_user_id) {
      InsCookieHandle.updateCookie(temp_cookies);

      InsLoginCookieHandle.clearCookie();
    }
  }
  return responseData;
};
// 解密返回值
export const responseDataDecode = (responseData: any) => {
  const { data } = responseData;
  if (data) {
    let atobString = atob(data);
    isJSON(atobString) ? (atobString = JSON.parse(atobString)) : void 0;
    responseData.data = atobString;
    return responseData;
  } else {
    return responseData;
  }
};
// 处理返回的错误
export function responseToError(responseData: any) {
  const { status_code, data, request } = responseData;
  if (typeof data === "string" && data.includes("not-logged-in")) {
    const errorData = { data: { message: "login_required" }, request };
    insErrorHanlde(errorData);
    return Promise.reject(errorData);
  }
  if (status_code === 200) {
    return data;
  } else {
    // ins返回的错误,非登录的api需要处理
    request.extra_data &&
      !request.extra_data.is_login &&
      insErrorHanlde(responseData);
    return Promise.reject(data);
  }
}

export const insErrorHanlde = (responseData: any) => {
  try {
    const { data, request } = responseData;
    const { extra_data } = request;
    const { user_id } = extra_data;
    const {
      message,
      comment_error_key,
      feedback_message,
      feedback_title
    } = data;
    switch (message) {
      case "login_required": {
        loginRequired(user_id);
        return;
      }
      case "challenge_required": {
        loginRequired(user_id);
        return;
      }
      case "feedback_required": {
        // comment feed不存在或者已关闭不需要使账号受限，排除这两种情况
        const shouldNotStartLimitation: boolean =
          comment_error_key === "comment_media_does_not_exist" ||
          comment_error_key === "comment_comments_disabled";
        // 一段时间内earn次数过多，需要出发limited times,时间为最大时间，不需要重新登录
        if (!shouldNotStartLimitation) {
          //
          act_users_action.feed_back_trigger_act_limit(user_id);
        }
        return;
      }
    }
  } catch (error) {
    void 0;
  }
};

export const loginRequired = (userId: string) => {
  // 弹出需要登陆的框：
  showLoginRequired(userId);
  // 改变act user的status
  act_users_action.trigger_login_required(userId);
};
